import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  FeatureActionFields,
  FeatureCommands,
  FeatureNames,
  HeatingCurveProperties,
  Feature,
  HeatingCurveCommands,
} from '@vi-iot/client';

import { GTMService } from '@services';
import { InstallationFeaturesStore } from '@store';

@Component({
  selector: 'app-heating-zone-heat-curve-panel',
  templateUrl: './heating-zone-heat-curve-panel.component.html',
  styleUrls: ['./heating-zone-heat-curve-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeatingZoneHeatCurvePanelComponent implements OnInit, OnDestroy {
  heatingCurve$: Observable<Feature<HeatingCurveProperties, HeatingCurveCommands>>;
  heatingCurveWidth: number;
  defaultRoomTemperature = 20;
  minFlowLimitTemperature = 0;
  maxFlowLimitTemperature = 100;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.heatingCurve$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.callForHeatHeatingCurve
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onShiftChange(value: number): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.callForHeatHeatingCurve,
      value,
      FeatureActionFields.shift,
      FeatureActionFields.shift,
      FeatureCommands.setCurve
    );

    this.gtmService.track('onSet', 'Heat curve shift', 'hzHeatingCurveManager');
  }

  onSlopeChange(value: number): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.callForHeatHeatingCurve,
      value,
      FeatureActionFields.slope,
      FeatureActionFields.slope,
      FeatureCommands.setCurve
    );

    this.gtmService.track('onSet', 'Heat curve slope', 'hzHeatingCurveManager');
  }
}
